import { IArea } from '@einfachgast/shared';

export default class AdminArea implements IArea {
  public id = 'admin-qr-code';
  public name = 'Admin-QR-Code';
  public label = 'Admin Label';
  public isDeactivated = false;
  public isLimitActive = false;
  public limit = 1;
}